// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"colorful-tooltip_tooltip_1xT","dismissButton":"colorful-tooltip_dismissButton_1fa","bottomLeft":"colorful-tooltip_bottomLeft_2Uh"};